import { render, staticRenderFns } from "./OtherUserProfilePage.vue?vue&type=template&id=1b64cc70&"
import script from "./OtherUserProfilePage.vue?vue&type=script&lang=js&"
export * from "./OtherUserProfilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports